const getInternalLink = (link: string) => {
  /*
    The following regex does the following:
      1. Matches if the url starts with `/pages/`
      2. Matches if the url starts with `http://www.lucidspark.com/pages` or `https://www.lucidspark.com/pages/` or `www.lucidspark.com/pages/` or `http://lucidspark.com/pages/` or `https://lucidspark.com/pages/`
      3. Matches if the url starts with `/` but doesn't start with `/blog` and `/documents` and `/users` and `/es/users/`
  */
  const internalRegex = /^(?:\/pages\/|^\/$|(?:https?:\/\/)?(?:www\.)?lucidspark\.com\/?(?:\/pages\/|$)|\/(?!(?:..\/|..-..\/)?documents|(?:..\/|..-..\/)?users?|blog))(.*)/;
  const result = internalRegex.exec(link);
  return result ? result[1] : null;
};

export default getInternalLink;
